import { Column, Entity, PrimaryGeneratedColumn } from "typeorm"

@Entity()
export class MavReading {

  @PrimaryGeneratedColumn({ name:"id" })
  id?: number
  
  @Column({nullable : false})
  camera_id!: string
  
  @Column({nullable : false})
  camera_name!: string

  @Column({nullable : false})
  processed_fps!: string

  @Column({nullable : false})
  startup_reason!: string

  @Column({nullable : true})
  uptime!: string

  @Column({nullable : true})
  sd_read_only!: string

  @Column({nullable : true})
  unsent_reads!: string

  @Column({type:'datetime', default:'2000-01-01 00:00:00'})
  timestamp!: Date

  @Column({type:'datetime', default:'2000-01-01 00:00:00'})
  offline_timestamp!: Date

  @Column({nullable : true})
  client!: string

  @Column({nullable : true})
  type!: string

  @Column({type:'datetime', default:'2000-01-01 00:00:00'})
  offline_timestamp_internal?: Date

  @Column({default: 10})
  email_delay?: number

  @Column({nullable:true, default: null})
  target_id?: number

  @Column({default: 0})
  sd_read_only_fail_count?: number

  @Column({default: 0})
  time_offset_fail_count?: number

  @Column({default: 0})
  time_offset?: number
}